module.exports = __webpack_public_path__ + "img/archive-inactive.19b22147.svg";